    <div class="bg-white pl-3 py-3 pr-0 verification_progress verification-process-container position-relative container-shadow d-flex justify-content-between align-items-center">
        <div class="w-75">
            <p class="heading-4 text-white">{{dataObj?.heading_text}}</p>
            <button 
                (click)="getVerificationStatus()" 
                *ngIf="dataObj?.button!=null" 
                class="cursor-pointer btn-design small filled mt-3 px-3" 
                >{{dataObj?.button?.text}}</button>
        </div>
        <img src="assets/themes/images/verification-progress-nudge.svg" 
            width="160px" />
    </div>